import Axios from 'utils/axios'

export default {
	namespaced: true,
	state: {
		list: [],
		condition: {},
	},
	mutations: {
		update(state, payload) {
			Object.assign(state, payload)
		}
	},
	actions: {
		fetch({ commit, state }) {
			const promise = Axios.post('/admin/element/tagList', {
				...state.condition,
			})
			promise.then(function (res) {
				commit('update', {
					list: res || [],
				})
			})
			return promise
		},
		fetchMore({ commit, state }) {
			const promise = Axios.post('/admin/element/tagList', {
				...state.condition,
			})
			promise.then(function (res) {
				commit('update', {
					list: state.concat(res || []),
				})
			})
			return promise
		},
	}
}
